/**
 * ProspectDocsSection Component
 * Wrapper for DocumentSection with error boundary
 */

import { ErrorBoundary } from '../../../../components/ErrorBoundary';
import { DocumentSection } from './documents/DocumentSection';

interface ProspectDocsSectionProps {
  prospectId: string;
  onResetSection: () => void;
}

export function ProspectDocsSection({
  prospectId,
  onResetSection,
}: ProspectDocsSectionProps) {
  return (
    <ErrorBoundary
      fallbackTitle="Documents Error"
      fallbackMessage="Failed to load documents. Please try again."
      onReset={onResetSection}
    >
      <DocumentSection prospectId={prospectId} />
    </ErrorBoundary>
  );
}
